export default "__VITE_ASSET__BPaRCZAp__"